import { Button, type ManagedModalComponentProps } from "@shapr3d/frontend-lib";

import useTranslation from "../../../hooks/useTranslation";
import { Modal } from "../../../lib/modal";

export const NonAutoRenewingUpgradeModal: React.FC<ManagedModalComponentProps> = (props) => {
  const { t, m } = useTranslation();

  return (
    <Modal
      {...props}
      title={t(m.NonAutoRenewingUpgradeModal.Title)}
      size="small"
      telemetryName="non_auto_renewing_upgrade"
    >
      <p>{t(m.NonAutoRenewingUpgradeModal.Body)}</p>
      <Button onClick={props.onClose}>{t(m.NonAutoRenewingUpgradeModal.CloseButton)}</Button>
    </Modal>
  );
};
